<template>
  <Sticky>
    <header class="exhibit-list-header">
      <div class="exhibit-list-header-top">
        <span class="exhibit-list-title"
          >Kingdee Cloud Building
          <span class="exhibit-list-subtitle">Art Space</span></span
        >
        <!-- <span class="exhibit-list-menu">•••</span> -->
      </div>
      <div class="exhibit-list-header-bottom">
        <div class="list-title">展出作品</div>
      </div>
    </header>
  </Sticky>

  <List class="van-tabs__content" :getData="getData" @init="onListInit">
    <template v-slot="{ data }">
      <div class="exhibit-list-items">
        <div
          class="exhibit-item"
          v-for="item in data"
          :key="item._id"
          @click="navToExhibit(item._id)"
        >
          <div class="exhibit-item-image">
            <img
              :src="getImageUrl(item)"
              :alt="item.name_cn"
              class="exhibit-image"
            />
          </div>
          <div class="exhibit-item-info">
            <h2 class="exhibit-item-title">
              {{ item.name_cn }}
              <div>{{ item.name_en }}</div>
            </h2>
            <div class="exhibit-item-artist">
              <span
                v-for="(artist, index) in item.artist"
                :key="artist._id || index"
              >
                {{ artist.name_cn }}
                <span class="en">{{ artist.name_en }}</span>
              </span>
            </div>
            <div class="exhibit-item-meta">
              {{ item.littleTitle }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </List>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { getExhibitList } from "@/service/api";
import router from "@/router";
import { Sticky } from "vant";
import List from "@/components/List.vue";

// 获取图片URL
const getImageUrl = (item) => {
  if (item.ex_images && item.ex_images.length > 0) {
    const firstImage = item.ex_images[0];
    if (typeof firstImage === "string") {
      return firstImage;
    }
    if (firstImage && firstImage.url) {
      return firstImage.url;
    }
    return firstImage;
  }
  return "";
};

// 跳转到展览详情
const navToExhibit = (id) => {
  router.push(`/exhibit?id=${id}`);
};

const listInstances = ref(null);
const onListInit = (instance) => {
  listInstances.value = instance;
};

const getData = ({ page, pageSize }) => {
  return getExhibitList({
    page,
    pageSize,
  });
};
</script>

<style lang="scss" scoped>
.exhibit-list-wrap {
  background: #fff;
  min-height: 100vh;
  font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  color: #222;
  padding: 40px 24px 90px;
}

.exhibit-list-header {
  width: 100%;
  box-sizing: border-box;
  padding: 24px;
  font-size: 12px;
  background: #fff;

  .exhibit-list-header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #241511;
    padding-bottom: 24px;
  }

  .exhibit-list-title {
    font-weight: 500;

    .exhibit-list-subtitle {
      color: #bdbdbd;
      margin-left: 4px;
    }
  }

  .exhibit-list-menu {
    font-size: 12px;
    color: #222;
    letter-spacing: 2px;
  }
}

.exhibit-list-header-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list-title {
  font-size: 16px;
  font-weight: bold;
  color: #241511;
  padding-top: 6px;
  border-top: 2px solid #241511;
  background: #fff;
}

.van-tabs__content {
  padding: 16px var(--van-padding-md);
}

.exhibit-list-title-section {
  margin-bottom: 32px;

  .exhibit-list-main-title {
    font-size: 28px;
    font-weight: bold;
    color: #222;
    margin: 0;
    padding-bottom: 16px;
    border-bottom: 3px solid #222;
  }
}

.exhibit-list-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.exhibit-item {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: opacity 0.2s;
  width: 48%;

  &:active {
    opacity: 0.7;
  }
}

.exhibit-item-image {
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  background: #f5f5f5;
  border-radius: 6px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  .exhibit-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.exhibit-item-info {
  .exhibit-item-title {
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 8px 0;
    color: #241511;
    line-height: 1.4;
    padding-bottom: 8px;
    border-bottom: 1px solid #8f8e8b;
  }

  .exhibit-item-artist {
    font-size: 16px;
    color: #8f8e8b;
    margin-bottom: 12px;
    line-height: 1.5;

    .en {
      color: #aaa;
      margin-left: 4px;
    }
  }

  .exhibit-item-meta {
    font-size: 15px;
    color: #666;
    line-height: 1.8;
  }
}
</style>
